var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_990_2220)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99994 9.91468L11.5353 13.45C11.7229 13.6376 11.9773 13.743 12.2426 13.743C12.5079 13.743 12.7623 13.6376 12.9499 13.45C13.1375 13.2624 13.2429 13.008 13.2429 12.7427C13.2429 12.4774 13.1375 12.2229 12.9499 12.0353L9.41327 8.50001L12.9493 4.96468C13.0421 4.87179 13.1158 4.76152 13.166 4.64018C13.2162 4.51883 13.2421 4.38878 13.242 4.25744C13.242 4.12611 13.2161 3.99607 13.1658 3.87475C13.1155 3.75342 13.0418 3.64319 12.9489 3.55035C12.8561 3.4575 12.7458 3.38386 12.6244 3.33363C12.5031 3.2834 12.373 3.25756 12.2417 3.25759C12.1104 3.25763 11.9803 3.28352 11.859 3.33381C11.7377 3.3841 11.6274 3.45779 11.5346 3.55068L7.99994 7.08601L4.46461 3.55068C4.3724 3.45513 4.2621 3.37889 4.14012 3.32643C4.01814 3.27396 3.88693 3.24631 3.75415 3.2451C3.62137 3.24388 3.48968 3.26912 3.36676 3.31934C3.24384 3.36957 3.13216 3.44377 3.03822 3.53762C2.94429 3.63146 2.86998 3.74308 2.81964 3.86595C2.7693 3.98882 2.74394 4.12049 2.74503 4.25327C2.74612 4.38605 2.77364 4.51728 2.82599 4.63931C2.87834 4.76134 2.95447 4.87172 3.04994 4.96401L6.58661 8.50001L3.05061 12.036C2.95514 12.1283 2.87901 12.2387 2.82666 12.3607C2.77431 12.4827 2.74679 12.614 2.7457 12.7468C2.7446 12.8795 2.76997 13.0112 2.82031 13.1341C2.87065 13.2569 2.94495 13.3686 3.03889 13.4624C3.13282 13.5563 3.24451 13.6305 3.36743 13.6807C3.49035 13.7309 3.62204 13.7561 3.75482 13.7549C3.8876 13.7537 4.0188 13.7261 4.14078 13.6736C4.26276 13.6211 4.37307 13.5449 4.46527 13.4493L7.99994 9.91468Z",
    fill: "#5EB067"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_990_2220"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseGreen);
export default __webpack_public_path__ + "static/media/close-green.e42f6233072dab7aee6c491a3332b046.svg";
export { ForwardRef as ReactComponent };